import { ALTERAR_MARCACAO_RESERVA_EXCESSO_BAGAGEM } from '../types'

export default function alterarMarcacaoReservaExcessoBagagem (reserva) {
  return {
    type: ALTERAR_MARCACAO_RESERVA_EXCESSO_BAGAGEM,
    payload: reserva
  }
}